import React from 'react';
import styles from './StatisticsBtnGroup.less';

class DeviceOnlineCount extends React.Component {
  render() {
    const { btnGroup, title, handelClick, start, end, cityData } = this.props;
    return (
      <div className={styles.deviceOnlineCount}>
        <p className={styles.title}>{title}</p>
        <div className={styles.countContainer}>
          {[...btnGroup].map((item, index) => (
            <div
              className={styles.count}
              key={index}
              onClick={() => handelClick(item, start, end, cityData)}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
export default DeviceOnlineCount;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsBtnGroup.js